import { useRouteMatch } from 'react-router-dom';
import { Box } from 'reflexbox';
import { useTranslation } from 'react-i18next';
import { Heading, Jumbo, Paragraph, Separator, QuillText as UIQuillText } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

export default function JobPosition() {
	const { params } = useRouteMatch<{ id: string }>();
	const { localize } = useLocalize();
	const { t } = useTranslation();

	const query = graphql.useJobPositionQuery({ variables: { id: params.id } });

	return (
		<>
			{!query.data && (
				<>
					<Jumbo.Skeleton wide />
					<Separator />
					<Box m={4}>
						<Heading.Skeleton mb={2} />
						<Paragraph.Skeleton />
					</Box>
				</>
			)}

			{query.data && (
				<>
					<Jumbo
						wide
						title={localize(query.data.jobPosition.jobTitle.title).text}
						footer={<Separator />}
					/>
					<Box m={4}>
						<Heading>{t('jobPosition.details.title.heading')}</Heading>

						{query.data.jobPosition.jobTitle.description &&
						!UIQuillText.isEmpty(
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							localize(query.data.jobPosition.jobTitle.description).text as any,
						) ? (
							<QuillText quill={localize(query.data.jobPosition.jobTitle.description).text} />
						) : (
							<Paragraph>{t('jobPosition.details.description.empty')}</Paragraph>
						)}
					</Box>
				</>
			)}
		</>
	);
}
